export const CLOSE_MODAL = "Modal/closeModal";
export const FORGOT_PASSWORD_MODAL = "forgotPasswordModal";
export const RECOVER_PASSWORD_MODAL = "recoverPasswordModal";
export const PICKUP_MODAL = "pickupModal";
export const SHIPPING_DETAIL_MODAL = "shippingDetailModal";
export const CONTACT_MODAL = "contactModal";
export const CONTACTS_LIST_MODAL = "contactsListModal";
export const CONFIRM_MODAL = "confirmModal";
export const ADDRESSES_LIST_MODAL = "addressesListModal";
export const ADDRESS_MODAL = "addressModal";
export const CANCEL_SHIPMENT_MODAL = "cancelShipmentModal";
export const EDIT_PICKUP_MODAL = "editPickupModal";
export const SHIPMENT_PROVE_MODAL = "shipmentProveModal";


export type ModalType =
  typeof FORGOT_PASSWORD_MODAL |
  typeof PICKUP_MODAL |
  typeof SHIPPING_DETAIL_MODAL |
  typeof CONTACT_MODAL |
  typeof CONTACTS_LIST_MODAL |
  typeof CONFIRM_MODAL |
  typeof ADDRESSES_LIST_MODAL |
  typeof ADDRESS_MODAL |
  typeof CANCEL_SHIPMENT_MODAL |
  typeof EDIT_PICKUP_MODAL |
  typeof SHIPMENT_PROVE_MODAL |
  typeof RECOVER_PASSWORD_MODAL;

export interface ModalOpenState<T, R> {
  modal: ModalType;
  data?: T;
  cb?: (result?: R) => void;
}

export interface ModalCloseState<R> {
  modal: ModalType;
  result?: R;
}

export interface IFormUser {
  name: string;
  email: string;
  user: string;
  password: string;
  driver: string;
  admin: boolean;
  status: boolean;
}

export interface IFormSelector {
  status: boolean;
  admin: boolean;
}

export interface ModalReducerType {
  openModalQuantity: number;
  [FORGOT_PASSWORD_MODAL]: any,
  [RECOVER_PASSWORD_MODAL]: any,
  [PICKUP_MODAL]: any,
  [SHIPPING_DETAIL_MODAL]: any,
  [CONTACT_MODAL]: any,
  [CONTACTS_LIST_MODAL]: any,
  [CONFIRM_MODAL]: any,
  [ADDRESSES_LIST_MODAL]: any,
  [ADDRESS_MODAL]: any,
  [CANCEL_SHIPMENT_MODAL]: any,
  [EDIT_PICKUP_MODAL]: any,
  [SHIPMENT_PROVE_MODAL]: any,
}
